export * from './ngx-signature-pad.module'
export * from './components'